export default (storeState, {payload}) => {
  let newState = Object.assign({}, storeState);
  newState.isCssSetting = payload;

  return newState;
};
